import { PUSH_RENDER_PDF_TEMPLATE_IMAGE } from './constants';
import fetchWithRefreshV2 from './fetchWithRefreshV2';

export interface Response {
    success: boolean;
    url: string;
    error?: string;
}

export default (formData: FormData): Promise<Response> =>
    fetchWithRefreshV2(PUSH_RENDER_PDF_TEMPLATE_IMAGE(true), {
        method: 'POST',
        body: formData,
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('upload pt sign image failed');
        }
    });
